export const environment = {
  production: true,
  buildId: '2999198487319891',
  configFile: 'config.json',
};
